// API Configuration
// This file handles API URLs for different environments
// Use REACT_APP_API_URL environment variable to override
// Default: http://localhost:5000 (development) or https://server2.bros-ksa.com (production)

const getApiUrl = () => {
  // Check for explicit API URL override
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  
  // In production build, use production server
  // In development, use localhost
  return process.env.NODE_ENV === 'production' 
    ? 'https://server2.bros-ksa.com'
    : 'http://localhost:5000';
};

export const API_URL = getApiUrl();

// Helper function to get full API endpoint
export const getApiEndpoint = (endpoint) => {
  // Remove leading slash if present to avoid double slashes
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
  return `${API_URL}/${cleanEndpoint}`;
};

// Helper function to get upload URL
export const getUploadUrl = (filename) => {
  if (!filename) return null;
  return `${API_URL}/uploads/${filename}`;
};

export default API_URL;

